import toast from "react-hot-toast";
import axiosInstance from "../../../axiosInstance";

export const getMyOrder = async (invoiceId, setData, setLoading) => {
  try {
    setLoading && setLoading(true);
    const res = await axiosInstance.get(`/paylater/details/${invoiceId}`);
    setData(res.data);
  } catch (err) {
    console.error(err);
    toast.error(err?.response?.data?.message || "Failed to load order");
  } finally {
    setLoading && setLoading(false);
  }
};
